import { lazy } from 'react';

import { type RouteConfig } from './routesConfig';

export const ROUTES = {
  ROOT: '/',
  ERROR: '/404',
  TEST: '/test',
  LOGIN: '/login',

  PLATFORM: '/platform',
  MONITORING: '/platform/monitoring',
  OLD_MONITORING: '/platform/old_monitoring',
  FILE_LOAD: '/platform/file_load',
  FILE_HISTORY: '/platform/file_history',
  FILE_REQUEST_INFO: '/platform/file_request_info',
  PATIENT: '/platform/patient',
  ADDRESSING: '/platform/addressing',
  WITH_NOVELTY: '/platform/patients_with_novelty',
  NOT_CONTACTED: '/platform/patients_not_contacted',
  PATIENT_LIST: '/platform/patient_list',
  PROGRAMMING: '/platform/programming',
  DISPENSATION: '/platform/dispensation',
  TECHNICAL_RECEPTION: '/platform/technical_reception',
  APPLICATION: '/platform/application',
  REPORTS: '/platform/reports'
};

// Lazy page imports
const Login = lazy(() => import('~pages/Public/Login/Login'));
const LandingPage = lazy(() => import('~pages/Public/LandingPage/LandingPage'));
const Error404 = lazy(() => import('~pages/Error404/Error404'));
const Home = lazy(() => import('~pages/Private/Home/Home'));
const Dashboard = lazy(() => import('~pages/Private/Dashboard/Dashboard'));
const FileLoad = lazy(
  () => import('~pages/Private/MassiveLoad/FileLoad/FileLoad')
);
const FileHistory = lazy(
  () => import('~pages/Private/MassiveLoad/FileHistory/FileHistory')
);
const FileRequestInfo = lazy(
  () => import('~pages/Private/MassiveLoad/FileRequestInfo/FileRequestInfo')
);
const Patient = lazy(() => import('~pages/Private/Patient/Patient'));
const Addressing = lazy(
  () => import('~pages/Private/Patients/Addressing/Addressing')
);
const PatientList = lazy(
  () => import('~pages/Private/Patients/PatientList/PatientList')
);
const NotContacted = lazy(
  () => import('~pages/Private/Patients/NotContacted/NotContacted')
);
const WithNovelty = lazy(
  () => import('~pages/Private/Patients/WithNovelty/WithNovelty')
);
const Programming = lazy(
  () => import('~pages/Private/Modules/Programming/Programming')
);
const Dispensation = lazy(
  () => import('~pages/Private/Modules/Dispensation/Dispensation')
);
const TechnicalReception = lazy(
  () => import('~pages/Private/Modules/TechnicalReception/TechnicalReception')
);
const Application = lazy(
  () => import('~pages/Private/Modules/Application/Application')
);
const Reports = lazy(() => import('~pages/Private/Reports/Reports'));

export const PUBLIC_ROUTES: RouteConfig[] = [
  { component: Error404, route: '*', props: { fullscreen: true } },
  { component: LandingPage, route: ROUTES.ROOT, index: true },
  { component: Login, route: ROUTES.LOGIN }
];

export const PRIVATE_ROUTES: RouteConfig[] = [
  { component: Error404, route: '*', props: { fullscreen: false } },
  { component: Home, route: ROUTES.PLATFORM },
  { component: Dashboard, route: ROUTES.MONITORING },
  { component: Dashboard, route: ROUTES.OLD_MONITORING },
  { component: FileLoad, route: ROUTES.FILE_LOAD },
  { component: FileHistory, route: ROUTES.FILE_HISTORY },
  { component: FileRequestInfo, route: ROUTES.FILE_REQUEST_INFO },
  { component: Patient, route: ROUTES.PATIENT },
  { component: PatientList, route: ROUTES.PATIENT_LIST },
  { component: NotContacted, route: ROUTES.NOT_CONTACTED },
  { component: WithNovelty, route: ROUTES.WITH_NOVELTY },
  { component: Addressing, route: ROUTES.ADDRESSING },
  { component: Programming, route: ROUTES.PROGRAMMING },
  { component: Dispensation, route: ROUTES.DISPENSATION },
  { component: TechnicalReception, route: ROUTES.TECHNICAL_RECEPTION },
  { component: Application, route: ROUTES.APPLICATION },
  { component: Reports, route: ROUTES.REPORTS }
];
